import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface TimeParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
// Target: Día del Padre, 19 de junio del año en curso (fin del día).
function getTarget(): Date {
  const now = new Date();
  let year = now.getFullYear();
  let target = new Date(year, 5, 19, 23, 59, 59); // mes 5 = junio
  // Si ya pasó este año, apunta al próximo año.
  if (target.getTime() < now.getTime()) {
    target = new Date(year + 1, 5, 19, 23, 59, 59);
  }
  return target;
}
function getRemaining(target: Date): TimeParts {
  const diff = Math.max(0, target.getTime() - Date.now());
  const totalSeconds = Math.floor(diff / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor(totalSeconds % 86400 / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
}
export function UrgencyBar() {
  const [target] = useState(getTarget);
  const [time, setTime] = useState<TimeParts>(() => getRemaining(target));
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getRemaining(target));
    }, 1000);
    return () => clearInterval(timer);
  }, [target]);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-bbq-urgency text-white py-3 px-4 sticky top-0 z-50 shadow-lg border-b border-red-900/50" data-id="element-276">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left text-sm sm:text-base font-medium" data-id="element-277">
        
        <div className="hidden sm:block text-red-300" data-id="element-278">|</div>
        <p className="text-gray-100" data-id="element-279">
          El Día del Padre se acerca. Consigue el regalo y recíbelo al instante.
        </p>
        <div className="flex items-center gap-2 bg-black/30 px-3 py-1.5 rounded-md font-display tracking-wider text-bbq-gold" data-id="element-280">
          <Clock size={16} className="text-bbq-gold shrink-0" data-id="element-281" />
          <div className="flex items-center gap-2" data-id="element-282">
            <TimeUnit value={time.days} label="días" data-id="element-283" />
            <span className="text-red-300/70" data-id="element-284">:</span>
            <TimeUnit value={pad(time.hours)} label="hrs" data-id="element-285" />
            <span className="text-red-300/70" data-id="element-286">:</span>
            <TimeUnit value={pad(time.minutes)} label="min" data-id="element-287" />
            <span className="text-red-300/70" data-id="element-288">:</span>
            <TimeUnit value={pad(time.seconds)} label="seg" data-id="element-289" />
          </div>
        </div>
      </div>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number | string;
  label: string;
}) {
  return <span className="flex flex-col items-center leading-none" data-id="element-290">
      <span className="text-base sm:text-lg font-bold tabular-nums" data-id="element-291">
        {value}
      </span>
      <span className="text-[9px] text-red-200/80 uppercase tracking-wide mt-0.5" data-id="element-292">
        {label}
      </span>
    </span>;
}